const ActionNames = require("./ActionNames");
const AggressionNames = require("./AggressionNames");
const EventNames = require("./EventNames");
const LeaderNames = require("./LeaderNames");
const PactNames = require("./PactNames");
const TacticNames = require("./TacticNames");
const TechnologyNames = require("./TechnologyNames");
const TerritoryNames = require("./TerritoryNames");
const WarNames = require("./WarNames");
const WonderNames = require("./WonderNames");

const CardTypes = require("./CardTypes")

const CardNames = 
{
    ActionNames,
    AggressionNames,
    EventNames,
    LeaderNames,
    PactNames,
    TacticNames,
    TechnologyNames,
    TerritoryNames,
    WarNames,
    WonderNames,
}

module.exports = 
{
    CardNames,
    CardTypes,
}